// Utilities
import moment from 'moment';
import { defineStore } from 'pinia'
import router from '@/router'
import HttpPlugin from '@/plugins/requests'
import axios from 'axios';
let User = localStorage.getItem('User') ? JSON.parse(localStorage.getItem('User')) : false;
/**/

export const useAppStore = defineStore('app', {
  state: () => ({
    tryToURL: '/',
    User: User,
    minDateRegular: moment().subtract(1, 'day'),
    minDateManager: moment().subtract(2, 'months'),
    events: [],
    startStr: '',
    routeLogs: [],
    filter:{},
    visitOrder: {},
  }),

  actions: {
    setTryToURL (url) {
      this.tryToURL = url
    },
    setEvents (events) {
      this.events = events;
    },
    setStartStr (startStr) {
      this.startStr = startStr
    },
    addRouteLog (route) {
      this.routeLogs.push(route)
    },
    setFilter (filter) {
      this.filter = filter
    },
    setVisitOrder (visitOrder) {
      this.visitOrder = visitOrder
    },  
    getUser (){
      let User = localStorage.getItem('User') ? JSON.parse(localStorage.getItem('User')) : false;
      if (!User) {
        console.log('get User in stores');
        axios.get('/accounts').then(response => {
                  localStorage.setItem('User', JSON.stringify(response.data));
                  User = JSON.parse(localStorage.getItem('User'));
                  this.User=User;
              }).catch(error => {
                  console.log(error);
                  router.push({ path: '/logout' });
              });
      } else this.User=User;
    }

  }
})
